import React, { useState } from 'react';
import { User } from 'lucide-react';
import ModeSelector from './ModeSelector';

function RecordTab({ relatives, families, selectedFamily, currentUserUuid, onStartRecording }) {
  const [selectedRelative, setSelectedRelative] = useState(null);

  const getInitial = (name) => name ? name[0].toUpperCase() : '?';

  const getProfileImageUrl = (relative) => {
    return relative.profile?.profilePictureUrl || relative.profilePictureUrl || null;
  };

  if (selectedRelative) {
    return (
      <ModeSelector
        relative={selectedRelative}
        families={families}
        selectedFamily={selectedFamily}
        onSelectMode={(mode, calloutQuestion) => {
          onStartRecording(selectedRelative, mode, calloutQuestion);
        }}
        onBack={() => setSelectedRelative(null)}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white p-4">
      <h2 className="text-lg font-bold mb-2 px-1">Record a Memory</h2>
      <p className="text-gray-400 text-sm mb-4 px-1">Choose who you're recording for</p>

      {relatives.length === 0 ? (
        <div className="text-center py-12">
          <User className="w-16 h-16 text-gray-600 mx-auto mb-4" />
          <p className="text-gray-400">No family members found</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {relatives.map((relative) => {
            const imageUrl = getProfileImageUrl(relative);
            return (
              <div
                key={relative.uuid}
                onClick={() => setSelectedRelative(relative)}
                className="relative aspect-square rounded-3xl overflow-hidden cursor-pointer hover:scale-[1.03] transition-transform duration-200 bg-gray-800"
              >
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt={relative.name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-gray-700">
                    <span className="text-4xl font-semibold text-gray-400">
                      {getInitial(relative.name)}
                    </span>
                  </div>
                )}

                {/* Name overlay */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3 pt-8">
                  <p className="font-semibold text-white text-sm drop-shadow-lg">{relative.name}</p>
                  <p className="text-xs text-gray-300 drop-shadow">{relative.relationship}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default RecordTab;
